module.exports = __webpack_public_path__ + "img/portugal-other-heart-diseases-male.c90e8d99.png";